<script lang="ts">
  import Heading from "../../components/atoms/Heading.svelte";
  import type { FacilityInformation, Person, Product } from "../../helpers/types";
  import usePurchaseFlow from "../../providers/usePurchaseFlow";
  import ProductPrices from "../../components/organisms/ProductPrices.svelte";
  import { getDefaultProductOrder } from "../../helpers/helperMethods";

  const { state: store, send } = usePurchaseFlow();
  let selectedProductId = $state($store.context.selectedProductId);
  let selectedProduct: Product | undefined = $state();
  let selectedAddons = $store.context.additionalProducts ?? [];
  let facilityInformation = $state({ ...$store.context.facilityInformation });
  let preSetZipcode: string | undefined = undefined;
  let showSelectProductError = $state(false);

  const onClickContinue = () => {
    if (!selectedProduct) {
      showSelectProductError = true;
      return;
    }
    send("SET_PRODUCT_ID", { selectedProductId: selectedProduct.id });
    send("SET_PRODUCT_TYPE", { productType: selectedProduct.type });
    send("SET_START_DATES", { startDates: selectedProduct.startDates });
    send("SET_ZIP_CODE", {
      data: {
        zipcode: preSetZipcode ? preSetZipcode : (facilityInformation.zipcode ?? "").toString(),
      },
    });
    if (
      selectedProductId !== undefined &&
      selectedProductId !== selectedProduct.id &&
      selectedProduct.addons !== undefined
    ) {
      const updatedAddons = selectedProduct.addons
        .filter((addon) => selectedAddons.includes(addon.id))
        .map((addon) => addon.id);
      send("SET_ADDITIONAL_PRODUCTS", { additionalProducts: updatedAddons });
    }
    send("NEXT");
  };

  const setUserData = (
    facilityInformation: FacilityInformation,
    person: Person,
    requiresLimePurchase: boolean
  ) => {
    preSetZipcode = facilityInformation.zipcode ? facilityInformation.zipcode.toString() : "";
    send("SET_FACILITY_INFORMATION", { facilityInformation });
    send("SET_PERSON", { person });
    send("SET_REQUIRES_LIME_PURCHASE", {
      requiresLimePurchase,
    });
  };

  const removeSelectedProductId = () => {
    send("SET_PRODUCT_ID", { selectedProductId: undefined });
  };
</script>

<ProductPrices
  bind:showSelectProductError
  purchaseFlowType={$store.context.purchaseFlowType}
  purchasekey={$store.context.checkPurchaseId ? $store.context.checkPurchaseId : undefined}
  {setUserData}
  productOrder={getDefaultProductOrder()}
  estimation={$store.context.estimation}
  bind:selectedProductId
  bind:selectedProduct
  bind:zipcode={facilityInformation.zipcode}
  campaign={$store.context.campaign}
  {removeSelectedProductId}
  goBack={() => send("BACK")}
  {onClickContinue}
>
  <Heading class="text-Neutral900" variant="primary">Vilken typ av elpris vill du ha?</Heading>
</ProductPrices>
